import styled from "@emotion/styled";
import { Link } from "react-router";

import career from "@/../../hypetrain/static/img/career-sq.png";
import jobSearch from "@/../../hypetrain/static/img/job-search-sq.png";
import leadership from "@/../../hypetrain/static/img/leadership-sq.png";
import life from "@/../../hypetrain/static/img/life-sq.png";
import { Box, Flex } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { Container } from "@/components/pieces/bootstrap";
import { StyledTitle } from "@/components/pieces/marketing/Titles";
import { BRAND_PURPLE } from "@/css/constants";

export function SpecialtyTiles() {
  return (
    <Box py={70}>
      <Container>
        <StyledTitle>Coaching for every career goal</StyledTitle>
        <Grid mt={60}>
          <SpecialtyContainer>
            <SpecialtyImage
              style={{
                background: "linear-gradient(-25deg,#38ced1 30%,#2474e7 76%)",
              }}
            >
              <Link to="/leadership-coaching">
                <img width="100%" src={leadership} />
              </Link>
            </SpecialtyImage>
            <SpecialtyContent>
              <Box>
                <SpecialtyTitle>
                  <Link to="/leadership-coaching">Leadership Coaching</Link>
                </SpecialtyTitle>
                <Box>
                  Invest in your founders, VPs, first-time managers, & everybody
                  in between.
                </Box>
              </Box>
              <Link to="/leadership-coaching">Learn more</Link>
            </SpecialtyContent>
          </SpecialtyContainer>
          <SpecialtyContainer>
            <SpecialtyImage
              style={{
                background:
                  "linear-gradient(-25deg, rgb(194, 60, 255) 18%, rgb(117, 27, 177) 76%)",
              }}
            >
              <Link to="/career-coaching">
                <img width="100%" src={career} />
              </Link>
            </SpecialtyImage>
            <SpecialtyContent>
              <Box>
                <SpecialtyTitle>
                  <Link to="/career-coaching">Career Coaching</Link>
                </SpecialtyTitle>
                <Box>
                  Find your direction and develop in areas that will accelerate
                  your career.
                </Box>
              </Box>
              <Link to="/career-coaching">Learn more</Link>
            </SpecialtyContent>
          </SpecialtyContainer>
          <SpecialtyContainer>
            <SpecialtyImage
              style={{
                background: "linear-gradient(139deg, #0c5595 0%, #00b8c7 100%)",
              }}
            >
              <Link to="/life-coaching">
                <img width="100%" src={life} />
              </Link>
            </SpecialtyImage>
            <SpecialtyContent>
              <Box>
                <SpecialtyTitle>
                  <Link to="/life-coaching">Life Coaching</Link>
                </SpecialtyTitle>
                <Box>
                  Learn how to remove obstacles standing in your way for a
                  better life.
                </Box>
              </Box>
              <Link to="/life-coaching">Learn more</Link>
            </SpecialtyContent>
          </SpecialtyContainer>
          <SpecialtyContainer>
            <SpecialtyImage
              style={{
                background: "linear-gradient(-25deg, #b279fa 18%, #6b74e6 76%)",
              }}
            >
              <Link to="/job-search-coaching">
                <img width="100%" src={jobSearch} />
              </Link>
            </SpecialtyImage>
            <SpecialtyContent>
              <Box>
                <SpecialtyTitle>
                  <Link to="/job-search-coaching">Job Search Coaching</Link>
                </SpecialtyTitle>
                <Box>
                  Succeed in your transition and have better outcomes than you
                  could solo.
                </Box>
              </Box>
              <Link to="/job-search-coaching">Learn more</Link>
            </SpecialtyContent>
          </SpecialtyContainer>
        </Grid>
      </Container>
    </Box>
  );
}

const Grid = styled(Box)`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: ${breakpoints.md}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: ${breakpoints.sm}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const SpecialtyContainer = styled(Flex)`
  flex-direction: column;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  font-size: 18px;
  background-color: #fff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
`;

const SpecialtyContent = styled(Flex)`
  padding: 24px;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  a {
    margin-top: 8px;
    color: ${BRAND_PURPLE};
    font-weight: 500;
  }
`;

const SpecialtyImage = styled(Flex)`
  justify-content: center;
  align-items: bottom;
  overflow: hidden;
`;

const SpecialtyTitle = styled("h3")`
  margin: 0 0 4px;
  font-size: 24px;

  a {
    color: #000;
  }
`;
